
export const getXhrStatusCode = (xhr)=>
  xhr.statusCode ? xhr.statusCode().status : xhr.status;


export const getGenericErrorMessage = ()=>
  (
    'An unexpected error occurred. Please try again later. '+
    'You can contact support@zoomforth.com for more assistance and you can try refreshing the page.'
  );

export const getDefaultErrorStringForStatusCode = (statusCode)=> {

  if (statusCode >= 500 && statusCode <= 599) {
    return 'An error occurred with Zoomforth. An engineer has been notified. We\'ll be working to fix this as soon as possible.';

  } else if (statusCode == 403) {
    return 'You are not logged in or you are not permitted to perform that action.';

  } else if (statusCode == 404) {
    return '404 Not Found—the resource you\'re trying to access does not exist or you are not permitted to access it.';

  } else if (statusCode >= 400 && statusCode <= 499) {
    return 'There was an error with the request you made.';

  } else {
    return null;
  }
};

export const getDefaultErrorStringForXhr = (data)=> {
  if (data.type && data.type == 'fileuploadfail'){
    return 'An error occurred while processing your file. An engineer has been notified. We\'ll be working to fix this as soon as possible.';
  } 

  try {
    return JSON.parse(data.responseText).error.message;
    
  } catch (e){
    const message = getDefaultErrorStringForStatusCode(
      getXhrStatusCode(data)
    );

    if (message) {
      return message;

    } else {
      return 'Could not connect to server—make sure that your internet is working. It\'s also possible the Zoomforth servers are temporarily being down—please contact support if the problem persists.';

    }

  }
};
